<template>
  <Dialog
    :close-on-escape="false"
    :closable="false"
    class="dialog-without-title dialog-content-p-0"
    v-model:visible="visible"
    :style="{width: '648px'}"
    :modal="true"
  >
    <div class="wrapper">
      <div class="icon-error"></div>

      <h3 class="title">
        <slot name="title" />
      </h3>

      <div class="text">
        <slot />
      </div>

      <div class="buttons p-fluid">
        <slot name="buttons" />
      </div>

    </div>
    <template #footer />
  </Dialog>
</template>

<script setup>
import {defineEmits, defineProps} from "vue";
import {useVModel} from "@vueuse/core";

const emit = defineEmits(['update:visible']);
const props = defineProps({
  visible: {type: Boolean, required: true},
});

const visible = useVModel(props, 'visible', emit);

const close = () => emit('update:visible', false);

</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.wrapper {
  width: 100%;
  max-width: toRem(320);
  text-align: center;
  margin: 0 auto;
  padding-bottom: toRem(10);
}

.icon-error {
  display: inline-block;
}

.title {
  margin-bottom: 0;
  margin-top: toRem(8);
  font-weight: bold;
  //font-size: toRem(28);
}

.buttons {
  margin-top: toRem(16);
}

.text {
  margin-top: toRem(5);
  font-size: toRem(18);
  color: $textSecondaryColor;
}

</style>
